import React from "react";

const MainHeading = ({ title }) => {
  return (
    <div className="title-h5-1" style={{ color: "#1C1C2C", marginBottom: "1rem" }}>
      {title}
    </div>
  );
};

export default MainHeading;
